import { render, staticRenderFns } from "./VisibleLinks.vue?vue&type=template&id=1f8d139f&scoped=true"
import script from "./VisibleLinks.vue?vue&type=script&lang=ts"
export * from "./VisibleLinks.vue?vue&type=script&lang=ts"
import style0 from "./VisibleLinks.vue?vue&type=style&index=0&id=1f8d139f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8d139f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8d139f')) {
      api.createRecord('1f8d139f', component.options)
    } else {
      api.reload('1f8d139f', component.options)
    }
    module.hot.accept("./VisibleLinks.vue?vue&type=template&id=1f8d139f&scoped=true", function () {
      api.rerender('1f8d139f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/VisibleLinks.vue"
export default component.exports